export class LivestreamEnvironment {
  public static getName = () => 'benzinga-livestream';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
